jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupSearch();
	setupFancyFocus();
	setupResourcesFilter();
	setupTooltips();
	setupScrollDetect();
	setupAddMenuTitle();
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars(){
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname){
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;

function setupSearch() {
	
	jQuery('.search-button').on('click', function(e){
		
		var html = jQuery('html');
		var searchButton = jQuery(this);
		var isHeader = searchButton.parents('header').length;
		
		if(!html.hasClass('search-open')) {
		
			e.preventDefault();
			
			if(isHeader) {
				html.addClass('search-open-header search-open');
				jQuery('#search-header-desktop').focus();
			} else {
				html.addClass('search-open-footer search-open');
				jQuery('#search-footer').focus();
			}
			
		}
		
	});
	
	jQuery('.search-container form').on('click', function(e){
				
		e.stopPropagation();
		
	});
	
	jQuery('html').on('click', function(e){
		jQuery('html').removeClass('search-open-header search-open-footer search-open');
	});
	
}

function setupFancyFocus(){	 
	var formElements = jQuery('input, textarea');
	formElements.on('focus', function(){
		jQuery(this).closest(".gfield").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest(".gfield").removeClass('focus');
		}
		
	});
}

function setupResourcesFilter() {
	
	if(jQuery("#resource-filters").length) {
		
		jQuery("#resource-filters .filter").on("change", function(){
			
			jQuery('#resource-search').val("");
			adjustURL();
			location.reload();
			
		});
		
	}
	
}

function gatherSelectedTerms() {
	
	var terms = {};

	jQuery('#resource-filters .filter').each(function(){

		var current = jQuery(this);
		var taxonomy = current.attr('data-tax');
		var value = current.val();

		terms[taxonomy] = value;

	});

	return terms;

}

function adjustURL() {
	
	var terms = gatherSelectedTerms();
	var search = jQuery('#resource-search').val();
	var url = new URL(window.location.href);
	
	for(const key in terms) {
		
		if(terms[key]) {
			url.searchParams.set(key, terms[key]);
		} else {
			url.searchParams.delete(key);
		}
		
	}
	
	if(search) {
		url.searchParams.set('search', search);
	} else {
		url.searchParams.delete('search');
	}
	
	history.replaceState({}, "", url);
	
}
function setupTooltips(){
	tippy('.tooltip', {
	  theme: 'midnight',
	  animation: 'slide-in',
	  interactive: true,
	  allowHTML: true,
	  content(reference) {
		  const id = reference.getAttribute('data-template');
		  const template = document.getElementById(id);
		  return template.innerHTML;
		}
	});
}

function setupScrollDetect(){
	
	jQuery(window).on('scroll', function(){
		
		var offset = jQuery(window).scrollTop();
		var html = jQuery('html');
		
		if(offset > 220) {
			html.addClass('not-top');
		} else {
			html.removeClass('not-top');
		}
		
	});
	
}
function setupAddMenuTitle(){
	jQuery('#main-nav li').each(function() {
		var menuItem = jQuery(this).children('a');
		var title = menuItem.text();
		menuItem.attr('title', title);
	});
}